// Child-facing WonderLabs destinations. A path selects a mission; it never grants access.
export const WONDERLABS_ROUTE_TO_SLUG = Object.freeze({
  rover: "wind-powered-car-mission",
  "glow-city": "conductive-dough-mission",
  "breeze-station": "electric-spiral-mission",
  "robot-artist": "robot-artist-mission",
  "flood-rescue": "flood-rescue-bridge",
  "flood-rescue-bridge": "flood-rescue-bridge",
});

// /wonderlabs is a backwards-compatible alias for the Inventors catalog.
// Existing individual-mission URLs retain their original Journey identities.
// The catalog only determines which tiles appear on the home screen.
export const getWonderLabsEntryRoute = (pathname) => {
  const normalized = String(pathname || "").replace(/\/+$/, "") || "/";
  if (normalized === "/wonderlabs" || normalized === "/wonderlabs/inventors") {
    return { isWonderLabs: true, slug: null, catalog: "inventors" };
  }
  if (normalized === "/wonderlabs/explorers") {
    return { isWonderLabs: true, slug: null, catalog: "explorers" };
  }
  const match = /^\/wonderlabs\/([a-z0-9-]+)$/.exec(normalized);
  if (!match) return { isWonderLabs: false, slug: null, catalog: null };
  return {
    isWonderLabs: true,
    slug: WONDERLABS_ROUTE_TO_SLUG[match[1]] || null,
    catalog: "inventors",
  };
};
